/** @file Skins panel body: skins by name (default marked), duplicate, make default, entries. */
import { entriesByName } from '@pose2d/format/doc/entriesByName';
import { useState } from 'react';
import { Button } from '../../ui-kit/Button';
import { freshName } from '../rigKit/freshName';
import { listHandlers } from '../rigKit/listHandlers';
import { NamedList } from '../rigKit/NamedList';
import type { RigView } from '../rigKit/rigView';
import { SkinEntries } from './SkinEntries';

/** The selection falls back to the default skin; the default skin cannot be deleted (skin.setDefault another first). */
export function SkinsView({ doc, t, run }: RigView) {
  const [picked, setPicked] = useState<string | null>(null);
  const skins = entriesByName(doc.skins);
  const selected = picked !== null && Object.hasOwn(doc.skins, picked) ? picked : doc.defaultSkin;
  const create = (copyFrom?: string): void => {
    const base = copyFrom === undefined ? 'skin' : `${doc.skins[copyFrom]?.name ?? 'skin'}-copy`;
    const name = freshName(base, skins.map(([, s]) => s.name));
    run([{ name: 'skin.create', input: copyFrom === undefined ? { name } : { name, copyFrom } }]);
  };
  const rows = skins.map(([id, s]) => (id === doc.defaultSkin ? { id, name: s.name, note: t('panels.skins.default') } : { id, name: s.name }));
  return (
    <div className="rig-body">
      <NamedList t={t} label={t('panels.skins.title')} rows={rows} selected={selected} onSelect={setPicked} onCreate={() => { create(); }}
        locked={new Set([doc.defaultSkin])} {...listHandlers('skin', run)} />
      <div className="rig-actions">
        <Button label={t('panels.skins.duplicate')} onClick={() => { create(selected); }} />
        <Button label={t('panels.skins.makeDefault')} disabled={selected === doc.defaultSkin} onClick={() => { run([{ name: 'skin.setDefault', input: { target: selected } }]); }} />
      </div>
      <SkinEntries doc={doc} t={t} run={run} skin={selected} />
    </div>
  );
}
